// extracted by mini-css-extract-plugin
export default {"container":"Usuario_container__d62by","foto":"Usuario_foto__LEnl-","iconeUsuario":"Usuario_iconeUsuario__fZl-H","nomeUsuario":"Usuario_nomeUsuario__sTCBM"};